// extracted by mini-css-extract-plugin
export default {"outlet":"Main_outlet__XbK05","left-nav":"Main_left-nav__0ViOf"};